import React, { useRef, useState, useEffect } from 'react';
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormGroup, Grid, IconButton, TextField, Typography } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from '../../../../GlobalFunction/checkAndLock';
import UnLock from '../../../../GlobalFunction/UnLock';
import CloseIcon from '@mui/icons-material/Close';

const columns = [
    { id: 'RowNum', label: 'Sr.No', minWidth: 170 },
    { id: 'FoodSubGrpName', label: 'FoodSubGrpName', minWidth: 170 },
    { id: 'Abrv', label: 'Abrv', minWidth: 170 },
    { id: 'Remark', label: 'Remark', minWidth: 170 },
];

const FoodSubGrp = () => {
    const [formData, setFormData] = useState({
        FoodGrpName: '',
        FoodGrpId: '',
        FoodSubGrpId: '',
        FoodSubGrpName: '',
        FoodSubGrpImg: '',
        Abrv: '',
        Remark: ''
    });
    const [error, setError] = useState({
        FoodClass: false,
        FoodAbvr: false
    });
    const [mode, setMode] = useState('view');
    const [Status, setStatus] = useState("1");
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [currentFoodsubGrpId, setCurrentFoodsubGrpId] = useState(null);
    const [Grp, setGrp] = useState([]);
    const [lastInsertedId, setLastInsertedId] = useState(null);
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const location = useLocation();
    const navigate = useNavigate();
    const foodClassRef = useRef(null);
    const foodAbrvRef = useRef(null);
    const remarkRef = useRef(null);
    const [imgIcon, setImgIcon] = useState(null);
    const [imgIconName, setImgIconName] = useState(null);

    useEffect(() => {
        if (location.state && location.state.FoodSubGrpId) {
            setCurrentFoodsubGrpId(location.state.FoodSubGrpId);
            fetchFoodSubGroup(location.state.FoodSubGrpId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location])

    const fetchFoodSubGroup = async (id, flag) => {
        try {
            const response = await axiosInstance.post(`MstFoodSubGrp/RetriveMstFoodSubGrp`, {
                FoodSubGrpId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const foodData = response.data.Data[0];
                const fixedIconUrl = (url) => {
                    if (!url) return '';
                    return url.replace(/^http:\/(?!\/)/, 'http://');
                };
                const fixedImg = fixedIconUrl(foodData.FoodSubGrpImg);

                setFormData({
                    FoodGrpId: foodData.FoodGrpId,
                    FoodSubGrpName: foodData.FoodSubGrpName,
                    Abrv: foodData.Abrv,
                    Remark: foodData.Remark
                });
                setStatus(foodData.Status.toString() || "0");
                setImgIcon(fixedImg ? `${fixedImg}?t=${new Date().getTime()}` : null);
                setIsFormDisabled(true);
                setCurrentFoodsubGrpId(foodData.FoodSubGrpId);
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.error('Failed to fetch food sub group data');
            }
        } catch (error) {
            toast.error('Error fetching food sub group data. Please try again.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            try {
                const res = await axiosInstance.post('MstFoodSubGrp/GetMstFoodSubGrpDashBoard', {
                    start: 1,
                    PageSize: 1,
                    SearchText: ""
                })

                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                }
            } catch (error) {
                toast.error("Error while printing the data.")
            }
        };
        getRow();
    }, [])

    useEffect(() => {
        const fetchGrp = async () => {
            try {
                const response = await axiosInstance.post(`MstFoodGrp/GetdrpMstFoodGrp`,
                    {
                        Flag: ""
                    }
                );
                if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                    setGrp(response.data.Data);
                } else {
                    toast.info("No record found.");
                }
            } catch (error) {
                toast.error("Error fetching Group. Please try again.");
            }
        };
        fetchGrp();
    }, []);

    const handlePrevious = async () => {
        if (currentFoodsubGrpId && currentFoodsubGrpId > 1) {
            await fetchFoodSubGroup(currentFoodsubGrpId, "P");
        }
    };

    const handleNext = async () => {
        if (currentFoodsubGrpId) {
            await fetchFoodSubGroup(currentFoodsubGrpId, "N");
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            if (e.target === foodClassRef.current) {
                foodAbrvRef.current.focus();
            } else {
                remarkRef.current.focus();
            }
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            FoodGrpName: '',
            FoodGrpId: '',
            FoodSubGrpName: '',
            Abrv: '',
            Remark: ''
        });
        setCurrentFoodsubGrpId(null);
        setTimeout(() => {
            foodClassRef.current.focus();
        }, 0);
    };

    const handleEdit = async () => {
        let Flag = await checkAndLock(currentFoodsubGrpId, 'MstFoodSubGrp', 'FoodSubGrpId');
        switch (Flag) {
            case 0:
                setMode('edit');
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record alredy locked", { autoClose: 500 });
                break;
            default:
                toast.info('Something went wrong', { autoClose: 500 })
        }
    };

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleConfirmDelete = async () => {
        let Flag = await checkAndLock(currentFoodsubGrpId, 'MstFoodSubGrp', 'FoodSubGrpId');
        switch (Flag) {
            case 0:
                setOpenConfirmDialog(false);
                const response = await axiosInstance.post('MstFoodSubGrp/DeleteMstFoodSubGrp', {
                    FoodSubGrpId: currentFoodsubGrpId
                });

                if (response.data.Status === 0) {
                    toast.success(response.data.Message || 'Record deleted');
                    await fetchFoodSubGroup(currentFoodsubGrpId, "P");
                    setStatus("1");
                    setMode('view');
                    setIsFormDisabled(true);
                } else {
                    toast.warn(response.data.Message);
                }
                break;
            case 1:
                toast.info("Record already locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record failed to locked", { autoClose: 500 });
                break;
            default:
                toast.info("Something went wrong", { autoClose: 500 });
        }
    };

    const handleExit = () => {
        navigate('/foodsubtable');
    };

    const handleSubmit = async () => {
        let hasError = false;

        if (!formData.FoodSubGrpName) {
            toast.error('Food sub group is required.');
            setError(prev => ({ ...prev, FoodSubGrpName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, FoodSubGrpName: false }));
        }

        if (!formData.FoodGrpId) {
            toast.error('Food group is required.');
            setError(prev => ({ ...prev, FoodGrpId: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, FoodGrpId: false }));
        }

        if (hasError) {
            return;
        }

        try {
            const payload = {
                FoodGrpId: formData.FoodGrpId,
                FoodSubGrpName: formData.FoodSubGrpName,
                Abrv: formData.Abrv,
                Remark: formData.Remark,
                FoodSubGrpImg: imgIcon?.startsWith('data:') ? imgIcon : formData.imgIcon,
                ImgName: imgIconName,
                Status: Status
            };
            let response;
            if (mode === 'edit') {
                payload.FoodSubGrpId = currentFoodsubGrpId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axiosInstance.post('MstFoodSubGrp/UpdateMstFoodSubGrp', payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axiosInstance.post('MstFoodSubGrp/InsertMstFoodSubGrp', payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedId(response.data.Data)
                    await fetchFoodSubGroup(response.data.Data);
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentFoodsubGrpId(response.data.Data);
                } else {
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.info(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            toast.error("Error while saving.");
        }
    };

    const handleCancel = async () => {
        try {
            if (currentFoodsubGrpId) {
                await fetchFoodSubGroup(currentFoodsubGrpId, "L"); // fetch the same record
            } else {
                setFormData({
                    FoodGrpName: '',
                    FoodGrpId: '',
                    FoodSubGrpId: '',
                    FoodSubGrpName: '',
                    FoodSubGrpImg: '',
                    Abrv: '',
                    Remark: ''
                });
                setImgIcon(null);
                setImgIconName(null);
            }

            await UnLock(currentFoodsubGrpId, 'MstFoodSubGrp', 'FoodSubGrpId');
            setStatus("1");
            setMode("view");
            setIsFormDisabled(true);
        } catch (error) {
            toast.error("Error while canceling.");
        }
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleIconImage = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImgIcon(reader.result);
                setImgIconName(file.name);
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <>
            <Box className='form-container' sx={{ height: { xs: '700px', sm: '550px' } }}>
                <ToastContainer />
                <Grid container spacing={1} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant='contained'
                                size='small'
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' } }}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant='contained'
                                size='small'
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF' }}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>
                        <Typography
                            variant='h5'
                            sx={{
                                margin: 'auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            Food Sub Group Master
                        </Typography>

                        <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
                            <CrudButtons
                                moduleName={"Food SubGroup Master"}
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_field'>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={6} lg={6} className='form_field'>
                                <Autocomplete
                                    disabled={mode === "view"}
                                    options={Grp}
                                    getOptionLabel={(option) => option.FoodGrpName || ""}
                                    value={Grp.find((g) => g.FoodGrpId === formData.FoodGrpId) || null}
                                    onChange={(event, newValue) => {
                                        setFormData((prev) => ({
                                            ...prev,
                                            FoodGrpId: newValue ? newValue.FoodGrpId : "",
                                        }));
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={
                                                <span>
                                                    Food Group <span style={{ color: "red" }}>*</span>
                                                </span>
                                            }
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={6}>
                                <TextField
                                    id='FoodSubGrpName'
                                    name='FoodSubGrpName'
                                    label={<span>Food Sub Group<span style={{ color: 'red' }}>*</span></span>}
                                    variant='filled'
                                    fullWidth
                                    className='custom-textfield'
                                    value={formData.FoodSubGrpName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={foodClassRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={6}>
                                <TextField
                                    id='Abrv'
                                    name='Abrv'
                                    label='Abrv'
                                    variant='filled'
                                    fullWidth
                                    className='custom-textfield'
                                    value={formData.Abrv}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={foodAbrvRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                                <TextField
                                    id='Remark'
                                    name='Remark'
                                    label='Remark'
                                    variant='filled'
                                    fullWidth
                                    className='custom-textfield'
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={1}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={Status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label='Status'
                                    />
                                </FormGroup>
                            </Grid>

                            <Grid item xs={12} sm={1}>
                                <Box
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        border: '1px dashed #000',
                                        borderRadius: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: '#fff',
                                        cursor: 'pointer',
                                        position: 'relative',
                                        mx: 'auto',
                                    }}
                                    onClick={() => document.getElementById('small-image-upload').click()}
                                >
                                    {imgIcon ? (
                                        <img
                                            src={imgIcon}
                                            alt="Upload"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    ) : (
                                        <Typography variant="caption" color="textSecondary" textAlign="center">
                                            +
                                        </Typography>
                                    )}

                                    {imgIcon && (
                                        <IconButton
                                            size="small"
                                            sx={{
                                                position: 'absolute',
                                                top: 0,
                                                right: 0,
                                                width: 16,
                                                height: 16,
                                                padding: 0,
                                                backgroundColor: 'rgba(255,255,255,0.7)',
                                                '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setImgIcon('');
                                                setImgIconName('');
                                            }}
                                            disabled={isFormDisabled}
                                        >
                                            <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                    )}

                                    <input
                                        type="file"
                                        id="small-image-upload"
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                        onChange={handleIconImage}
                                        disabled={isFormDisabled}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_button'>
                        {mode === 'view' && (
                            <>
                                <Button variant='contained' sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant='contained' sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit} disabled>
                                    Cancel
                                </Button>
                            </>
                        )}

                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant='contained' sx={{ mr: 1 }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant='contained' sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 && <ReportTable
                    columns={columns}
                    rows={rows}
                    title='Food Class Master'
                    contentRef={contentRef}
                    customStyles={{ backgroundColor: '#f5f5f5' }}
                />}
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby='alert-dialog-title'
                area-describedby='alert-dialog-description'
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        Are you sure want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button size='small' sx={{
                        backgroundColor: '#ad2929',
                        color: '#ffffff',
                        '&:hover': {
                            backgroundColor: '#ad2929',
                            color: '#ffffff'
                        }
                    }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button size='small' sx={{
                        backgroundColor: '#1d7427',
                        color: '#ffffff',
                        '&:hover': {
                            backgroundColor: '#1d7427',
                            color: '#ffffff'
                        }
                    }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default FoodSubGrp;